import React, { useEffect, useState } from "react";
import Layout from "../../../app/Layout";
import HeaderContent from "../General/HeaderContent";
import Breadcrumb from "../General/Breadcrumb";
import UpdateObservationsReporte from "../../components/Formularios/UpdateObservationsReporte";
import TableReport from "./reportesExcel/TableReport";
import ModalBasic from "../../components/Modals/ModalBasic";
import ExportExcel from "./reportesExcel/ExportExcel";
import ModalLarge from "../../components/Modals/ModalLarge/ModalLarge";
import TablaNotaDiscente from "../../components/Tablas/TablaNotaDiscente";
import MensajeLoading from "../../components/MensajeLoading";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import * as moment from "moment";

import "./generalPosventa.scss";
//Redux
import { connect, useSelector } from "react-redux";
import {
  listarProyectos,
  listarSesionesCursos,
} from "../../../actions/cursosActions";
import {
  listarReporteGeneralPosventa,
  listarNotasDiscente,
  actualizarEstadoDesertado
} from "../../../actions/reportesActions";
import useSelectProyecto from "../../../hooks/useMultiSelectProyectos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

const GeneralPosventa = (props) => {
  //State redux
  const { cantidadesTotales , reporte, loading } = props;

  //Funciones
  const {
    listarReporteGeneralPosventa,
    listarNotasDiscente,
    actualizarEstadoDesertado
  } = props;

  const [dataReporte, setDataReporte] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLarge, setShowModalLarge] = useState(false);
  const [reporteEstudiante, setReporteEstudiante] = useState({});
  const [proyecto, SelectProyecto] = useSelectProyecto(null)
  const { usuario } = useSelector(state => state.usuario);
  //Guardar Reporte para editar
  const guardarReporte = (report) => {
    setReporteEstudiante(report);
    setShowModal(true);
  };

  //Ocultar modal
  const updateShowModal = (value) => {
    setShowModal(value);
  };

  const verNotasSesiones = (idMatriculaDiscente) => {
    listarNotasDiscente(idMatriculaDiscente);
    updateModalLarge(true);
  };

  const updateModalLarge = (value) => {
    setShowModalLarge(value);
  };


  const calcularRitmo = (cumplimiento, report) => {
    const sinData = !report.promedio_final && !report.cant_asistidas && !report.puntos_adicionales;
    if (sinData) return 'SIN DATA';
    if (cumplimiento >= 90) return 'AL DÍA';
    if (cumplimiento >= 75) return 'PREVENTIVO';
    if (cumplimiento >= 50) return 'RETRASADO';
    return 'CRÍTICO';
  };

  const calcularSemaforo = (report, cumplimiento) => {
    const sinData = !report.promedio_final && !report.cant_asistidas;
    if (sinData) return 'GRIS';
    if (report.pago === 'MOROSO') return 'ROJO';
    if (cumplimiento >= 90) return 'VERDE';
    return 'AMBAR';
  };

  const llenarDataReporte = async () => {
    let dataGenerado = [];
    reporte.map((report, index) => {
      const notaAlumno = parseFloat(report.promedio_final) || 0;
      const notaOptima = parseFloat(report.promedio_optimo) || 0;
      const puntosMax = parseFloat(report.puntos_maximos_disponibles) || 0;
      const cumplimiento = notaOptima > 0 ? Math.min(100, Math.round((notaAlumno / notaOptima) * 100)) : 0;

      dataGenerado = [
        ...dataGenerado,
        {
          id: index + 1,
          id_matricula_proyecto: report.id_matricula_proyecto,
          color_estado: calcularSemaforo(report, cumplimiento),
          proyecto: report.nombre_proyecto,
          nombre: report.nombre_usuario,
          apellido: report.apellido_usuario,
          dni: report.dni,
          correo: report.email,
          telefono: report.celular,
          pago: report.pago || '---',
          importe_deuda: (report.importe_deuda).toFixed(2),
          cant_total_sesiones: report.cant_total_sesiones,
          cant_se_realizada: report.cant_se_realizada,
          cant_asistidas: report.cant_asistidas,
          promedio_optimo: notaOptima,
          promedio_final: notaAlumno,
          cumplimiento: cumplimiento,
          progreso: cumplimiento,
          ritmo: calcularRitmo(cumplimiento, report),
          fecha_edicion: report.fecha_edicion
            ? moment(report.fecha_edicion).format("DD MMM YYYY")
            : "---",
          hora_edicion: report.fecha_edicion
            ? moment(report.fecha_edicion).format("LTS")
            : "---",
          turno: report.turno,
          estado_pago: report.pago,
          observaciones: report.observaciones || "No hay observaciones",
          estado_academico:
            report.id_estado_est === 1 ? "Activo"
            : report.id_estado_est === 2 ? "Ambar"
            : report.id_estado_est === 3 ? "Desertado" : "",
          puntos_adicionales: report.puntos_adicionales || 0,
          puntos_inedi: report.puntos_evaluacion || 0,
          total_puntos: report.total_puntos || 0,
          puntos_maximos_disponibles: puntosMax,
          inedirank: report.inedirank,

          button: (
            <>
              <Button
                type="button"
                variant='info'
                size='xs'
                onClick={() => guardarReporte(report)}
              > 
                <FontAwesomeIcon icon={faEdit}/>
              </Button>
            </>
          ),
        },
      ];
    });

    setDataReporte(dataGenerado);
  };

  //Listar sesiones del proyecto cuando se seleccione un proyecto
 /* useEffect(() => {
    if (proyecto && Object.keys(proyecto).length > 0) {
     // console.log(proyecto);
     listarReporteGeneralPosventa(proyecto);
    }
  }, [proyecto]);*/

const consultarSeguimiento = () =>{
   // if (proyecto && Object.keys(proyecto).length > 0) {
    // console.log(proyecto);
     listarReporteGeneralPosventa(proyecto);
  //  }
}
const sesionesRealizadasPrograma = Number(reporte?.[0]?.cant_se_realizada_programa || 0);
const totalSesionesPrograma = Number(reporte?.[0]?.cant_total_sesiones_programa || 0);

const porcentajeAvancePrograma =
  totalSesionesPrograma > 0
    ? Math.min(100, Math.round((sesionesRealizadasPrograma / totalSesionesPrograma) * 100))
    : 0;

const NOTA_MAXIMA = 20;
const notaIdealActual = parseFloat(reporte?.[0]?.promedio_optimo || 0);
const porcentajeNotaIdeal = Math.min(100, Math.round((notaIdealActual / NOTA_MAXIMA) * 100));



  useEffect(() => {
   llenarDataReporte();
  }, [reporte]);

  return (
    <Layout>
      <HeaderContent title="Progreso" icon="insert_chart_outlined" subItem={usuario.id_tp_nivel_usuario==='5'? 'Imagina si nuestros estudiantes terminaran todo lo que comenzaran: ¿Cómo cambiarías sus vidas?': null} />
      <Breadcrumb
        link={[
          { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
          { url: "", nombre: "Área de Trabajo" },
          { url: "", nombre: "Progreso" },
        ]}
      />
      <div className="general-posventa">
        <div className="row content-select-curso my-4">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-5 filtro">
  <label htmlFor="">Producto</label>
  <SelectProyecto />
</div>

<div className="col-md-2 pt-4">
  <button className="btn btn-primary" onClick={consultarSeguimiento}>
    <i className="fa fa-search" style={{ marginRight: "5px" }}></i>
    Consultar
  </button>
</div>

<div className="col-md-5 pt-4">
  <div className="avance-programa">
    <div className="avance-programa__info">
      <span>Avance de clases</span>
      <strong>{porcentajeAvancePrograma}%</strong>
    </div>
    <div className="avance-programa__barra">
      <div className="avance-programa__progreso" style={{ width: `${porcentajeAvancePrograma}%` }} />
    </div>
    <div className="avance-programa__detalle">
      {sesionesRealizadasPrograma} de {totalSesionesPrograma} clases desarrolladas
    </div>
  </div>

  <div className="avance-programa mt-2">
    <div className="avance-programa__info">
      <span>Nota ideal</span>
      <strong>{notaIdealActual.toFixed(2)} / {NOTA_MAXIMA}</strong>
      <span style={{ fontSize: '11px', color: '#888', marginLeft: '8px' }}>Nota óptima: {NOTA_MAXIMA}</span>
    </div>
    <div className="avance-programa__barra">
      <div className="avance-programa__progreso" style={{ width: `${porcentajeNotaIdeal}%`, background: '#3498db' }} />
    </div>
    <div className="avance-programa__detalle">
      {porcentajeNotaIdeal}% alcanzado sobre nota máxima de {NOTA_MAXIMA}
    </div>
  </div>
</div>

              <div className="col-md-4 filtro"></div>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>

        {loading !== null ? (
          <>
            <SpinnerLoading loading={loading}>
              <div className="box box-secondary">
                <h5
                  className="p-3 d-flex align-items-center mb-0"
                  style={{ color: "#434343" }}
                >
                  <i className="fas fa-list pr-2"></i>Lista de estudiantes
                </h5>
                <div className="box-body">
                <TableReport
                  rows={dataReporte}
                  verNotasSesiones={verNotasSesiones}
                />
                 <div style={{marginTop:'15px', padding:'8px' , display:'flex'}}>
                    <div style={{fontSize:'18px', margin:'8px'}}>
                      <span style={{fontWeight:'bold'}}>Total de Deuda:</span> S/. {cantidadesTotales.total_deuda}
                    </div>
                    <div style={{fontSize:'18px', margin:'8px'}}>
                      <span style={{fontWeight:'bold'}}>Total de Discentes:</span> {cantidadesTotales.cant_discentes}
                    </div>
                    <div style={{fontSize:'18px', margin:'8px'}}>
                      <span style={{fontWeight:'bold'}}>Total Rojos:</span> {cantidadesTotales.discentes_rojo}
                    </div>
                    <div style={{fontSize:'18px', margin:'8px'}}>
                      <span style={{fontWeight:'bold'}}>Total Ambar:</span> {cantidadesTotales.discentes_ambar}
                    </div>
                    <div style={{fontSize:'18px', margin:'8px'}}>
                      <span style={{fontWeight:'bold'}}>Total Verde:</span> {cantidadesTotales.discentes_verde}
                    </div>
                 </div>
              </div>
             
              </div>
             
            </SpinnerLoading>
          </>
        ) : (
          <MensajeLoading />
        )}
      </div>
      <ModalLarge
        title="Notas"
        show={showModalLarge}
        updateModalLarge={updateModalLarge}
      >
        <TablaNotaDiscente />
      </ModalLarge>
      <ModalBasic
        show={showModal}
        updateShowModal={updateShowModal}
        title="Reporte estudiante"
      >
        <UpdateObservationsReporte reporte={reporteEstudiante} proyectos={proyecto} />
      </ModalBasic>
      <ExportExcel />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  cantidadesTotales: state.reporte.cantidadesTotales,
  reporte: state.reporte.reporte,
  proyectos: state.cursos.proyectos,
  sesionesCurso: state.cursos.sesionesCurso,
  loading: state.reporte.loading,
});

const mapDispatchToProps = {
  listarProyectos,
  listarSesionesCursos,
  listarReporteGeneralPosventa,
  listarNotasDiscente,
  actualizarEstadoDesertado
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralPosventa);
